import { Routes } from '@angular/router';
import { authGuard } from './domains/shared/guards/auth-guard';
import { environment } from 'src/environments/environment';
import { canActivateFeature } from './features.guard';
import { AccessDeniedUiComponent } from '@psg/ui-common/access-denied/access-denied.ui-component';
import { GenericOutageUiComponent } from '@psg/ui-common/generic-outage/generic-outage.ui-component';
import { PageNotFoundUiComponent } from '@psg/ui-common/page-not-found/page-not-found.ui-component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: environment.landingRoute,
    pathMatch: 'full',
  },
  {
    path: 'case',
    canActivate: [canActivateFeature],
    loadChildren: () => import('@psg/cases/cases.routes').then((m) => m.caseRoutes),
    data: { feature: 'cases' },
  },
  {
    path: 'individual',
    canActivate: [canActivateFeature],
    loadChildren: () => import('@psg/individual/individual.routes').then((m) => m.individualRoutes),
    data: { feature: 'individuals' },
  },
  {
    path: 'user',
    canActivate: [authGuard, canActivateFeature],
    loadChildren: () => import('@psg/users/users.routes').then((m) => m.userRoutes),
    data: { feature: 'users', role: 'Admin' },
  },
  {
    path: 'server-error',
    component: GenericOutageUiComponent,
  },
  {
    path: 'access-denied',
    component: AccessDeniedUiComponent,
  },
  {
    path: 'not-found',
    component: PageNotFoundUiComponent,
  },
  // {
  //   path: '**',
  //   redirectTo: 'not-found',
  //   pathMatch: 'full',
  // },
];
